/*
 * Created by: cparaschiv
 * Date: 24.01.2013, 13:02
 */

TS.Constants = TS.Constants || {};

$.extend(TS.Constants,

/**
 * @namespace Constants
 * @property {number}  TS.Constants.ShowIndicatorDelay - Number of milliseconds before showing the AJAX indicator.
 */
{

    ownerProp: '__owner',
    repeaterProp: '_ownerProp',
    selectedItem: 'selectedItem',
    selectedItemObs: 'selectedItem()',

	EventTarget: '__EVENTTARGET',
	EventArgument: '__EVENTARGUMENT',
	AspNetForm: 'aspnetForm',

    ShowIndicatorDelay: 200,

    /**  @property {number} CommandTimeout - Number of milliseconds before a command times-out. */
    CommandTimeout: 3 * 1000, //3 seconds
    AjaxCfg: {
        timeout: 10 * 1000
    },

    Url: {
        GetComboData: 'GetComboData'
    }
});
